import { apiFormData } from '../configs/axiosConfigs';

export const updatePropertyComments = async(property_id: string, comment_id: string, requestBody, config: any = {}) => {
  return await apiFormData.put(`/properties/${property_id}/comments/${comment_id}`, requestBody, config);
};
